import * as React from 'react'

import { cn } from '@/lib/utils'

interface InputProps extends React.ComponentProps<'input'> {
  variant?: 'default' | 'blocker' | 'task' | 'new'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = 'default', ...props }, ref) => {
    return (
      <input
        type={type}
        autoComplete="off"
        className={cn(
          'flex h-9 w-full rounded-xs border p-1 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground bg-surface-neutralLight placeholder:text-contents-disabled border-border-default-neutral font-EN-KR-body1-regular text-contents-primary',
          'focus-visible:ring-0 focus-visible:ring-offset-0',
          'focus:outline-none focus:border-1 focus:border-border-default-focused ',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:text-contents-disabled',
          variant === 'blocker' &&
            'h-8 p-1 font-EN-KR-body2-regular text-contents-primary bg-surface-backgroundElevated border-border-default-neutral placeholder:text-contents-secondary focus:border focus:border-border-default-focused focus:placeholder:text-contents-disabled',
          variant === 'task' &&
            'h-8 p-1 font-EN-KR-body2-regular text-contents-primary bg-surface-backgroundElevated border-border-default-neutral placeholder:text-contents-secondary focus:border focus:border-border-default-focused focus:placeholder:text-contents-disabled',
          variant === 'new' &&
            'h-8 font-EN-KR-body2-regular text-contents-primary bg-surface-neutralMedium placeholder:text-contents-secondary border-transparent focus:border focus:border-border-default-focused focus:bg-surface-backgroundElevated focus:placeholder:text-contents-disabled',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
